/**
 * Detecta plano recorrente/assinatura (VIP etc.).
 * Aceita valores do cache (boolean), API (boolean) e legado (Sim/Não, YES/NO).
 */
export function enrichPlan(plan, catalogPlans) {
  if (!plan) {
    return plan;
  }
  const fromCatalog = (catalogPlans || []).find(p => String(p.id) === String(plan.id));
  if (!fromCatalog) {
    return plan;
  }
  return {
    ...fromCatalog,
    ...plan,
    setup_fee: plan.setup_fee != null ? plan.setup_fee : fromCatalog.setup_fee,
    fixed_price: plan.fixed_price != null ? plan.fixed_price : fromCatalog.fixed_price,
    recurring: plan.recurring != null ? plan.recurring : fromCatalog.recurring,
    interval_unit: plan.interval_unit || fromCatalog.interval_unit,
    name: plan.name || fromCatalog.name
  };
}

export function isPlanRecurring(plan) {
  if (!plan) {
    return false;
  }

  const recurring = plan.recurring;
  if (recurring === true || recurring === 'YES' || recurring === 'Sim' || recurring === 'Yes') {
    return true;
  }

  // VIP: adesão (setup_fee) + mensalidade (fixed_price)
  const setup = parseFloat(plan.setup_fee) || 0;
  const fixed = parseFloat(plan.fixed_price) || 0;
  if (setup > 0 && fixed > 0 && plan.interval_unit === 'MONTH') {
    return true;
  }

  if (plan.name && /vip/i.test(String(plan.name))) {
    return true;
  }

  if (recurring === false || recurring === 'NO' || recurring === 'Não' || recurring === 'Nao') {
    return false;
  }

  return false;
}
